import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

class Histoire extends Component {
state = {
    redirect:false,
    search: ''
    }

handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
}

render () {  
    return (
    <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <div className="histoire-content">
                        <h1><span>Qu'est-ce que le Club Aquatique les Piranhas du Nord (CAPN)</span></h1>   
                        <p>Le Club Aquatique les Piranhas du Nord (CAPN), dont le siège social est situé à la piscine Sophie-Barat, 
                        est un organisme sans but lucratif qui a été constitué dans le but d’offrir des services aquatiques,
                        de qualité, à prix abordable, à la population de l’arrondissement Ahuntsic/Cartierville.
                        Les disciplines offertes sont la natation, la nage synchronisée, le plongeon, le sauvetage et le water-polo.
                        Les cours offerts aux aînés, aux adultes et aux enfants ainsi que les camps de jour aquatique d’été et d’hiver, sont aussi gérés par le CAPN et non, 
                        comme la plupart le pense, par l’arrondissement. De plus, il offre aussi de l’emploi à une soixantaine d’étudiants, pratiquement tous issus du CAPN.<br/><br/>

                        Le CAPN est dirigé par un conseil d’administration formé de parents et/ou membres bénévoles,
                        élus lors de l’assemblée annuelle du mois de novembre.
                        Les membres du conseil d’administration se réunissent une dizaine de fois par année, pour améliorer et développer
                        la programmation du Club et s’adapter aux besoins constants de la population du quartier.
                        C’est grâce au CAPN et à l’implication constante des parents que vous et vos enfants jouissiez d’un service aquatique de grande qualité. <br/><br/>

                        Étant en partenariat avec l’arrondissement, nous bénéficions d’installations gratuites pour les entraînements et pour l’organisation de compétitions et profitons d’un site
                        enchanteur, envié par plusieurs autres sites aquatiques. Nous sommes donc très privilégiés.
                        Pour que les activités sportives du CAPN puissent se poursuivre dans les prochaines années et que vous et vos enfants puissiez en bénéficier,
                        il faut une grande participation de tous les parents et/ou membres du CAPN. Une bonne façon de commencer est de venir assister à la prochaine assemblée annuelle
                        qui a toujours lieu dans la première semaine de novembre.<br/><br/>
                        </p>
                    </div>

                    </Col>
                    </Row>
                </Col>


            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <div className="fixed-bottom-footer"><Footer /></div>
            </Col>
            </Col>
        </Row>
        </Container>
    </>
    )
}
}

export default Histoire
